import {Pipe, PipeTransform} from '@angular/core';
import {Shipment} from '../../_entities/shipments/shipment.entity';
import {StatesHelper} from '../../states/states.helper';
import Order from '../../_entities/orders/order.entity';

@Pipe({
    name: 'shipmentsOfOrder',
    pure: true
})
export class ShipmentsOfOrderPipe implements PipeTransform {
    transform(orderId: number): Shipment[] {
        const order = StatesHelper.ordersEntitiesState.entities[orderId];
        if (!order) return;
        return new Order(order).shipments;
    }
}
